import React from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { getFormValues, Field } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { numberFormat } from 'core/utilities'
import { StdCard } from 'components'
import { DataCell } from '../DataCell'
import { DetailContainer, Cont, SContDetail, ItemSummaryRow } from './styled'
import { RowFields } from '../../styled'
import { poItemColumns } from '../../data'

const PurchaseOrderDetailTab = (props) => {
  const { valueForm } = props
  const items = valueForm.items || []

  return (
    <StdCard title='Detail' style={{marginTop:'15px'}}>
      <DetailContainer>
        <Cont style={{ width: '100%', maxWidth: '100%' }}>
          <RowFields>
            <Field
              name='deliveryAddress'
              label='Delivery Address'
              type={type.text}
              component={FieldInput}
              editable={false}
            />
          </RowFields>
          <SContDetail>
            <ReactTable
              className='poItems'
              data={items}
              columns={poItemColumns}
              minRows={items.length > 10 ? 10 : items.length}
              defaultPageSize={10}
              showPagination={items.length > 10}
            />
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='itemSummaryLabel'>Total Amount:</div>
              <div className='summaryValue'>{numberFormat(valueForm.totalAmount, true)}</div>
              <div className='currency'>{valueForm.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='itemSummaryLabel'>Discount:</div>
              <div className='summaryValue'>{numberFormat(valueForm.discount, true)}</div>
              <div className='currency'>{valueForm.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='itemSummaryLabel'>After Discount Amount:</div>
              <div className='summaryValue'>{numberFormat(valueForm.afterDiscount, true)}</div>
              <div className='currency'>{valueForm.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='itemSummaryLabel'>Vat {valueForm.vatRate || (valueForm.vatAmount / (valueForm.afterDiscount / 100)).toFixed(2).replace('.00', '')}%:</div>
              <div className='summaryValue'>{numberFormat(valueForm.vatAmount, true)}</div>
              <div className='currency'>{valueForm.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <SContDetail>
            <ItemSummaryRow>
              <div className='itemSummaryLabel'>Net Amount:</div>
              <div className='summaryValue'>{numberFormat(valueForm.netAmount, true)}</div>
              <div className='currency'>{valueForm.currencyCode}</div>
            </ItemSummaryRow>
          </SContDetail>
          <RowFields>
            <Field
              name='paymentCondition'
              label='Payment Condition'
              rows={5}
              type={type.textArea}
              component={FieldInput}
              editable={false}
            />
          </RowFields>
          <RowFields>
            <Field
              name='remark'
              label='Remark'
              type={type.textArea}
              component={FieldInput}
              editable={false}
            />
          </RowFields>
        </Cont>
      </DetailContainer>
    </StdCard>
  )
}

const mapStateToProps = (state) => ({
  valueForm : getFormValues('formPO')(state)||{}
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderDetailTab)